import React from 'react';
import PropTypes from 'prop-types';
import HTMLDECODE from '../../utils/htmlDecode';

class FilterSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.selectOption = this.selectOption.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    document
      .getElementById('app')
      .addEventListener('click', this.hideMenu, false);
  }

  componentWillUnmount() {
    document
      .getElementById('app')
      .removeEventListener('click', this.hideMenu, false);
  }

  toggleMenu() {
    this.setState({ visible: !this.state.visible });
    if (this.props.onToggleMenu) {
      this.props.onToggleMenu();
    }
  }

  selectOption(e, opt) {
    e.preventDefault()
    this.handleChange(e, opt);
    this.toggleMenu();
  }

  hideMenu(e) {
    e.preventDefault()
    const { target } = e;

    if (target === document.querySelector(`#${this.props.id}`)) {
      return;
    }

    if (!target.dataset.filter) {
      if (this.state.visible === true) this.setState({ visible: false });
    }

    if (this.state.visible === true && target.dataset.filter) {
      this.handleChange(e, {
        order: target.dataset.order,
        label: target.dataset.label,
        layout: target.dataset.layout,
        code: target.dataset.code,
        id: target.dataset.id,
      });
    }
  }

  handleChange(event, opt) {
    this.toggleMenu();
    if (this.props.handleChange) {
      this.props.handleChange(event, opt);
    }
  }

  render() {
    const items = this.props.ordenamiento;
    return (
      <div className="filter">
        <div className="select2">
          <div className="c-select">
            <button
              className="c-select-button"
              id={this.props.id}
              key={this.props.id}
              onClick={this.toggleMenu}
            >
              {this.props.textSelect}
            </button>
            {this.state.visible && (
              <div className="c-select-options">
                <ul >
                  {items.map((item, i) => (
                    <li
                      data-filter
                      data-index={i}
                      data-order={item.order}
                      data-label={item.label || item.text}
                      data-code={item.code}
                      data-layout={item.layout}
                      data-id={item.id}
                      key={i}
                    >
                      {HTMLDECODE(item.label || item.text)}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

FilterSection.propTypes = {
  onToggleMenu: PropTypes.func,
  handleChange: PropTypes.func,
  ordenamiento: PropTypes.array.isRequired,
  textSelect: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default FilterSection;
